module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/NkMsCz/images/9780446198110.jpg?1733067596039",
      "alt": "This image is the cover for the book King of Storms, Isles/Templars"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("King of Storms, Isles/Templars\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Lady Sidony Macleod, the youngest daughter in her family, can't easily make decisions so she is content to have others lead.  But fate and the Knight Templars have other plans for her.  Sir Giffard Maclennan, a knight and Highland firebrand, is chosen first to lead a top secret mission for his brethren Templars; and second, to keep the Earl of Fife (who is hunting the secret that Giff is hiding) guessing. Giff's plan includes the delectable Sidony as his accomplice. Giff's impatience and rashness will annoy the more practical Sidony, while her tendency to plan "), _c('i', [_vm._v("everything")]), _vm._v(" will drive Giff craxy. As Giff and Sidony join forces to hide the Templars' secret, he will learn to temper his impulsive behavior, and she will learn to tolerate his unpredictable temper as they fall in love.  In the midst of being hunted by their formidable enemies, this romantic duo will be put to the ultimate test.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Amanda Scott\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("&lt;DIV&gt;&lt;B&gt;Amanda Scott&lt;/B&gt; is the author of over 62 romance novels and the recipient of the Romance Writers of America's prestigious RITA Award. She lives in Folsom, California, outside of Sacramento. She is a fourth-generation Californian.&lt;/DIV&gt;")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Warner Forever\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0